<app-module-header [title]="organization.organizationName + ' - ' + ('ORDER_LIST.TITLE' | transloco)"
[icon]="'playlist_add_check'"></app-module-header>

@if (isLoading) {
  <mat-progress-bar mode="indeterminate" class="mb-2"></mat-progress-bar>
}

<div class="page-container">
  <mat-tab-group syncTabsWithUrl dynamicHeight (selectedTabChange)="tabChanged($event)">

    <mat-tab label="{{ 'ORDER_LIST.PAGINATED_LIST' | transloco }}" urlKey="page-order-list">
      <div class="tab-content">
        <app-back-office24-order-list-pagination (incrementRequests)="incrementRequests()"
          (decrementRequests)="decrementRequests()" [isLoading]="isLoading">
        </app-back-office24-order-list-pagination>
      </div>
    </mat-tab>

    @if (organization?.config?.handleAdditionalServices) {
      <mat-tab
        label="{{ 'ORDER_LIST.ADDITIONAL_SERVICES_TAB' | transloco }}" urlKey="order-additional-services">
        <app-order-additional-service-list (incrementRequests)="incrementRequests()"
          (decrementRequests)="decrementRequests()" [isLoading]="isLoading">
        </app-order-additional-service-list>
      </mat-tab>
    }

    @if (myConfigService.hasOrganizationIdRole($safeNavigationMigration(organization?.organizationId), 'ParkingOperator', $safeNavigationMigration(organization?.organizationParentId)) || myConfigService.hasOrganizationIdRole($safeNavigationMigration(organization?.organizationId), 'ParkingAdministrator', $safeNavigationMigration(organization?.organizationParentId))) {
      <mat-tab label="{{ 'ORDER_LIST.DEBTS_TAB' | transloco }}" urlKey="debts">
        <app-debt-list (incrementRequests)="incrementRequests()"
          (decrementRequests)="decrementRequests()" [isLoading]="isLoading">
        </app-debt-list>
      </mat-tab>
    }

    @if (myConfigService.hasOrganizationIdRole($safeNavigationMigration(organization?.organizationId), 'ParkingOperator', $safeNavigationMigration(organization?.organizationParentId)) || myConfigService.hasOrganizationIdRole($safeNavigationMigration(organization?.organizationId), 'ParkingAdministrator', $safeNavigationMigration(organization?.organizationParentId)) || myConfigService.hasOrganizationIdRole($safeNavigationMigration(organization?.organizationId), 'ParkingSurveillance', $safeNavigationMigration(organization?.organizationParentId))) {
      <mat-tab label="LPR Logs"
        urlKey="lpr-logs">
        <app-lpr-logs (incrementRequests)="incrementRequests()" (decrementRequests)="decrementRequests()"
          [isLoading]="isLoading">
        </app-lpr-logs>
      </mat-tab>
    }

  </mat-tab-group>
</div>
